<template>
<div class="modal_wrapper">
  <div class='container'>
    <img :src=loading>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      loading: require('../../img/ajax-loader.gif'),
      showCompleteModal: false
    }
  }
}
</script>
<style scoped>
.container {
  display: table-cell;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/loadingModalWindow.vue